import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import Card from '../components/common/Card';
import Button from '../components/common/Button';
import Badge from '../components/common/Badge';
import Table from '../components/common/Table';
import { useAuth } from '../contexts/AuthContext';
import { FileText, Download, Upload } from 'lucide-react';
import { formatDate, formatFileSize } from '../utils/helpers';
import toast from 'react-hot-toast';

const DocumentosPage = () => {
  const { mockData } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');

  const documentos = React.useMemo(() => {
    let filtered = mockData?.documentos || [];

    if (searchTerm) {
      filtered = filtered.filter(d =>
        d.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.tipo.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return filtered;
  }, [mockData, searchTerm]);

  const columns = [
    {
      header: 'Nombre',
      cell: (row) => (
        <div className="flex items-center space-x-3">
          <FileText className="w-5 h-5 text-gray-400" />
          <span className="font-medium">{row.nombre}</span>
        </div>
      )
    },
    {
      header: 'Tipo',
      cell: (row) => (
        <Badge variant="default">{row.tipo.toUpperCase()}</Badge>
      )
    },
    {
      header: 'Tamaño',
      cell: (row) => formatFileSize(row.tamano)
    },
    {
      header: 'Fecha Subida',
      cell: (row) => formatDate(row.fechaSubida)
    },
    {
      header: 'Subido por',
      accessor: 'subidoPor'
    },
    {
      header: 'Acciones',
      cell: (row) => (
        <Button
          variant="outline"
          size="sm"
          icon={Download}
          onClick={(e) => {
            e.stopPropagation();
            toast.success(`Descargando ${row.nombre}...`);
          }}
        >
          Descargar
        </Button>
      )
    }
  ];

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Documentos</h1>
            <p className="text-gray-600 mt-1">Gestión documental centralizada</p>
          </div>
          <Button
            variant="primary"
            icon={Upload}
            onClick={() => toast.success('Función de subida de documentos')}
          >
            Subir Documento
          </Button>
        </div>

        <Card>
          <div className="mb-6">
            <input
              type="text"
              placeholder="Buscar documentos..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>

          <Table
            columns={columns}
            data={documentos}
          />
        </Card>
      </div>
    </Layout>
  );
};

export default DocumentosPage;
